import axiosInstance from '../axios/axiosInstance';
import { ExamImportRequest } from 'model/request';
import { Exam, Page } from '../model/response';

export const pageExams = async (params: any) => {
  const { data } = await axiosInstance.get<Page<Exam>>('exams/page', { params });
  return data;
};

export const findAllExams = async (subjectId?: string) => {
  const { data } = await axiosInstance.get<Exam[]>('exams', { params: { subjectId, fromCMS: true } });
  return data;
};

export const getFullExamDetail = async (examId: string) => {
  const { data } = await axiosInstance.get<ExamImportRequest>(`exams/${examId}:get-full-detail`);
  return data;
};

export const getGenerateRandomExam = async (examTemplateId: string) => {
  const { data } = await axiosInstance.get<ExamImportRequest>(
    `exams/exam-template/${examTemplateId}:generate-random-exam`,
  );
  return data;
};

export const saveExamRequest = async (examRequest: ExamImportRequest | null, practice: boolean) => {
  await axiosInstance.post('exams/save', examRequest, { params: { practice } });
};

export const updateApprovalStatus = async (id: string, approvalStatus: boolean) => {
  await axiosInstance.put(`exams/${id}/${approvalStatus}:update-approval-status`, { approvalStatus });
};

export const hasDeleteExamConfirm = async (examId: string) => {
  const { data } = await axiosInstance.get<boolean>(`exams/${examId}/has-delete-confirm`);
  return data;
};

export const deleteExam = async (examId: string) => {
  await axiosInstance.delete(`exams/${examId}`);
};
